import { createLogger } from 'redux-logger';
import { routerReducer as routing, routerMiddleware } from 'react-router-redux';
import { combineReducers, createStore, applyMiddleware, compose } from 'redux';
import { createBrowserHistory } from 'history';

export const history = createBrowserHistory(['/']);

const enhancers = [];
let preloadedState = {};
/* eslint-disable no-undef */
if (typeof window !== 'undefined') {
  preloadedState = window.__PRELOADED_STATE__ || {};
  if (typeof window.devToolsExtension === 'function') {
    enhancers.push(window.devToolsExtension());
  }
}
/* eslint-enable no-undef */

const reducers = combineReducers({ routing });
const composedEnhancers = compose(
  applyMiddleware(routerMiddleware(history), createLogger({ level: 'debug' })),
  ...enhancers
);

export default createStore(reducers, preloadedState, composedEnhancers);
